import { useLayoutEffect, useState } from 'react';
import { useLayout } from '@/hooks/useLayout';

const MOBILE_BREAKPOINT = 768;
const SIDEBAR_WIDTH_COLLAPSED = 80;
const SIDEBAR_WIDTH_EXPANDED = 256;
const REFERENCE_CONTENT_WIDTH = 768;
const MIN_SCALE = 0.6;

export const PageContentRoot = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { sidebarCollapsed } = useLayout();
  const [scale, setScale] = useState<number | null>(null);

  useLayoutEffect(() => {
    const updateScale = () => {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        setScale(null);
        return;
      }
      const sidebarWidth = sidebarCollapsed
        ? SIDEBAR_WIDTH_COLLAPSED
        : SIDEBAR_WIDTH_EXPANDED;
      const contentWidth = window.innerWidth - sidebarWidth;
      const newScale = Math.min(
        Math.max(contentWidth / REFERENCE_CONTENT_WIDTH, MIN_SCALE),
        1
      );
      setScale(newScale);
    };

    updateScale();
    window.addEventListener('resize', updateScale);
    return () => window.removeEventListener('resize', updateScale);
  }, [sidebarCollapsed]);

  const isScaled = scale !== null && scale < 1;

  return (
    <div
      className={`w-auto flex flex-col box-border min-h-screen transition-all ${sidebarCollapsed ? 'ml-20' : 'ml-64'}`}
    >
      <div
        className="flex flex-col flex-1 min-h-screen"
        style={
          isScaled && scale != null
            ? {
                transform: `scale(${scale})`,
                transformOrigin: 'top left',
                width: `${100 / scale}%`,
                height: 'auto',
              }
            : undefined
        }
      >
        {children}
      </div>
    </div>
  );
};
